import React from 'react';
import { Box } from '@mui/material';
import GiftSection from '../CardView/GiftSection';

const DesignContentPage7 = ({ data }) => {

    return (
        <Box
            sx={{
                position: 'relative',
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <div style={{ transform: "scale(0.9)", display: "flex", justifyContent: "center", width: "100%", paddingTop: "20px" }}>
                <GiftSection data={data} gifts={data.gifts || []} customMaxHeight="480px" isPreviewMode={true} />
            </div>
        </Box>
    );
};

export default DesignContentPage7;